<template>
    <component :is="type" :label="label" @click="click" :params="params" no-caps align="left" :style="this.params.type !== 'image' ? 'margin: 0px 15px 10px 15px' : ''" />
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
import ButtonTask from 'components/ui/extensions/ButtonTask';
import ButtonImage from 'components/ui/extensions/ButtonImage';
import SotButton from 'components/ui/design/SotButton';
//! import VueSocketIO from 'vue-3-socket.io';

export default {
    name: 'Button',
    mixins: [uiControlMixin],
    components: { ButtonTask, ButtonImage, SotButton },
    computed: {
        type () {
            if (this.params.to === 'task') {
                return 'ButtonTask';
            }
            if (this.params.to === 'create_cert3') {
                return 'DefaultButton';
            }
            /*
            if (this.params.to === 'course_page') {
                return 'DefaultButton';
            }
             */
            if (this.params.type === 'image') {
                return 'ButtonImage';
            }
            return 'SotButton';
        },
        label () {
            return this.params.label ?? 'Button';
        },
    },
    mounted () {
        // Подписаться на события сервера об изменении кнопки
        // console.log('button mounted');
        // console.log('VueSocketIO:', VueSocketIO);
    },
    data () {
        return {
            locked: false,
        };
    },
    methods: {
        click () {
            if (this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.params.id = this.view.id;
                this.$pages.push(this.params);
                this.locked = false;
            }, 300);
        },
    },
};
</script>

<style scoped lang="scss">
</style>
